import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import styled from '@emotion/styled';
import { withConfig } from 'src/withConfig';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { css, SerializedStyles } from '@emotion/react';

const setEventRowWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme, isOutrights: boolean): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            border-radius: ${theme.star.radius.medium};
            padding: ${isOutrights === true ? '0': theme.star.padding.small};
            background-color: ${isOutrights === true ? 'transparent': theme.star.eventRow.bgColor};
            gap: ${theme.star.gap.medium};
            min-height: 64px;
        `;
    }
    if (variant === DefaultComponentVariantType.TERTIARY) {
        return css`
            padding: ${isOutrights === true ? '0': theme.star.padding.medium};
            background-color: ${isOutrights === true ? 'transparent': theme.star.eventRow.bgColor};
            gap: ${theme.star.gap.medium};
            min-height: 64px;
            border-bottom: solid 1px ${theme.star.eventRow.borderColor};
        `;
    }
    return css`
        background-color: ${theme.star.eventRow.bgColor};
        border-top: solid 1px ${theme.star.eventRow.borderColor};
        border-bottom: solid 1px ${theme.star.eventRow.borderColor};
        border-left: solid 1px ${theme.star.eventRow.borderColor};
        margin: 0 0 -1px;
        min-height: 50px;
    `;
};

interface EventRowPropsType {
    variant: DefaultComponentVariantType | null;
    isOutrights: boolean;
}

export const EventRowWrapper = withConfig(theme => styled('div', { label: 'EventRowWrapper' })<EventRowPropsType>`
    ${({ variant, isOutrights }): SerializedStyles => setEventRowWrapper(variant, theme, isOutrights)}
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    position: relative;
    z-index: ${theme.star.zIndexGlobal.base};
`);

interface EventRowNameLinkPropsType {
    variant: DefaultComponentVariantType | null;
}

const setEventRowNameLink = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            padding: ${theme.star.padding.small} ${theme.star.padding.xMedium};
        `;
    }
    if (variant === DefaultComponentVariantType.TERTIARY) {
        return css`
            padding: ${theme.star.padding.small} ${theme.star.padding.xMedium};
        `;
    }
    return css`
        padding: ${theme.star.padding.medium} ${theme.star.padding.xMedium};
        gap: ${theme.star.eventRow.gap};
    `;
};

export const EventRowNameLink = withConfig(theme => styled(Link, { label: 'EventRowNameLink' })<EventRowNameLinkPropsType>`
    ${({ variant }): SerializedStyles => setEventRowNameLink(variant, theme)}
    align-items: flex-start;
    color: ${theme.star.eventRow.txtColor};
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    overflow: hidden;
    text-decoration: none;
    text-overflow: ellipsis;
    width: 100%;
`);

interface EventRowHeaderPropsType {
    variant: DefaultComponentVariantType | null;
}

const setEventRowHeader = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            background: ${theme.star.eventRow.bgColor};
            border-radius: ${theme.star.radius.medium};
        `;
    }
    if (variant === DefaultComponentVariantType.TERTIARY) {
        return css`
            background: ${theme.star.eventRow.bgColor};
            border-radius: ${theme.star.radius.medium};
        `;
    }
    return css``;
};

export const EventRowHeader = withConfig(theme => styled('div', { label: 'EventRowHeader' })<EventRowHeaderPropsType>`
    ${({ variant }): SerializedStyles => setEventRowHeader(variant, theme)}
    display: flex;
    flex: 1 1 0%;
    flex-flow: row nowrap;
    line-height: 1;
    min-width: 50px;
    transition: background-color .2s ease;
`);

export const EventRowMarkets = styled('div', { label: 'EventRowMarkets' })<EventRowPropsType>`
    min-width: 100%;
    margin-top: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? '4px' : variant === DefaultComponentVariantType.TERTIARY ? '4px' : '0'};
`;

export const EventRowSelections = withConfig(theme => styled('ul', { label: 'EventRowSelections' })<EventRowPropsType>`
    display: flex;
    flex-flow: row nowrap;
    font-weight: ${theme.star.fontWeight.bold};
    justify-content: center;
    gap: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.gap.small : variant === DefaultComponentVariantType.TERTIARY ? theme.star.gap.small : '0'};
`);

export const EventRowSelectionsElement = styled('li', { label: 'EventRowSelectionsElement' })`
    display: flex;
    height: 100%;
`;

export const EventRowMeta = withConfig(theme => styled('div', { label: 'EventRowMeta' })`
    align-items: center;
    color: ${theme.star.eventRow.txtColorQuaternary};
    display: flex;
    font-size: ${theme.star.eventRow.typography.fontSizeSecondary};
    line-height: ${theme.star.eventRow.typography.lineHeightSecondary};
    white-space: nowrap;
`);
